/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync>): BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync {
        let obj = Object.assign(new BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync(), model);
        BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync>): BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync {
        if (!model) return null;
        return BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync.newInstance(<BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * CoreStack master account owning the dimension (GraphDB repo + named-graph scope).
     */
    master_account_id: string;

    /**
     * Cost-allocation dimension whose detected anomalies are (re)projected into GraphDB.
     */
    dimension_id: string;

}
